export default "__VITE_ASSET__BgMehOK1__"